/* eslint-disable */
const messages = {
  'about.title': 'Teâđ kääzzkõõzzâst  Vaʹrrjem päiʹǩǩ',
  'app.about': 'Teâđ kääzzkõõzzâst',
  'app.login': 'Ǩeʹrjtõõđ sizz',
  'app.logout': 'Ǩeʹrjtõõđ åålǥas',
  'app.my_reservations': 'Jiijjad vaʹrrjõõzz',
  'app.search': 'Ooccmõš',
  'home.title': 'Ouddseidd - Vaʹrrjem päiʹǩǩ',
  'home.what_purpose': 'Mâiʹd haaʹlääk tueʹjjeed?',
  'imagepanel.images': 'Kaart',
  'login.back': 'Mååusat',
  'login.login': 'Ǩeʹrjtõõđ sizz',
  'login.login_and_save': 'Ǩeʹrjtõõđ sizz da ruõkk',
  'login.modal_title': 'Ǩeʹrjtõõđ sizz',
  'login.password': 'Peittnââmar',
  'login.username': 'Ǩeʹrjjkoort nââmar',
  'multiday.begin': 'Älgg',
  'multiday.cancel': 'Maaccât',
  'multiday.end': 'Poott',
  'multiday.header': 'Tueʹjjed mueʹdd peeiʹv vaʹrrjõs',
  'myreservations.no_ordinary': 'Jeäʹla takainallšem vaʹrrjõõzz kuâsttjemnalla.',
  'myreservations.no_preliminary': 'Jeäʹla valmšteei vaʹrrjõõzz kuâsttjemnalla.',
  'myreservations.ordinary_reservations': 'Takainallšem vaʹrrjõõzz',
  'myreservations.page_header': 'Jiijjad vaʹrrjõõzz',
  'myreservations.preliminary_reservations': 'Valmšteei vaʹrrjõõzz',
  'myreservations.title': 'Jiijjad vaʹrrjõõzz - Vaʹrrjem päiʹǩǩ',
  'notfound.title': '404 Seidd ij kaunnu - Vaʹrrjem päiʹǩǩ',
  'ResourceAvailability.available': 'Tâʹlles friij',
  'ResourceAvailability.availableAt': 'Frijjân čiâss {time}',
  'ResourceAvailability.closed': 'Ǩidd pijjum',
  'ResourceAvailability.reserved': 'Vaʹrrjum obbpeeiʹv',
  'reservation.accept': 'Priim',
  'reservation.all': 'Puk',
  'reservation.cancel': 'Maaccât',
  'reservation.edit': 'Teev',
  'reservation.information': 'Teâđ',
  'reservation.reject': 'Heelǥâd¤',
  'reservation.reservation_status': 'Vaʹrrjõõzz staattus',
  'reservation_calendar.back': 'Mååusat',
  'reservation_calendar.choose_time': 'Vaalâž ääiʹj, koozz haaʹlääk tueʹjjeed vaʹrrjõõzz.',
  'reservation_calendar.confirm_changes': 'Raavâd muttsid',
  'reservation_calendar.go_to_selected': 'Mõõn vaalšum sâjja',
  'reservation_calendar.reserve': 'Vaʹrre',
  'reservation_calendar.reserving': 'Vaʹrrjet...',
  'reservation_calendar.saving': 'Ruõkkât...',
  'reservation_calendar.today': 'Täʹbbe',
  'reservation_cancel.are_you_sure': 'Leäk-a snäätnai što haaʹlääk maaccted {num, plural, one {pueʹtti vaʹrrjõõzz} other {pueʹtti vaʹrrjõõzz}}:',
  'reservation_cancel.back': 'Mååusat',
  'reservation_cancel.by_contact': 'Vaʹrrjõõzz maacctummuš âlgg tueʹjjeed pääiʹǩest vaʹstteei veʹrneeʹǩǩ mieʹldd.\n            Jõs haaʹlääk maaccted vaʹrrjõõzz leʹbe tueʹjjeed muttsid vaʹrrjemäigga tâʹl feʹrttjak leeʹd õhttvuõđâst pääiʹǩest\n            vaʹstteei veʹrnekka.',
  'reservation_cancel.cancel': 'Maaccât vaʹrrjõõzz',
  'reservation_cancel.canceling': 'Maacctet...',
  'reservation_cancel.do_not_cancel': 'Jeäʹl maaccât vaʹrrjõõzz',
  'reservation_cancel.titleConfirm': 'Maacctõõzz raʹvvjummuš',
  'reservation_cancel.titlePreliminary': 'Vaʹrrjõõzz maacctõs',
  'reservation_form.address': 'Addrõs',
  'reservation_form.address_city': 'Gåårad',
  'reservation_form.address_street': 'Uuʹlecaddrõs',
  'reservation_form.address_zip': 'Pååʹštnââmar',
  'reservation_form.back': 'Mååusat',
  'reservation_form.billing_address': 'Laasktõsaddrõs',
  'reservation_form.comments': 'Kommeeʹnt',
  'reservation_form.comments_help': 'Vaʹrrjõõzz vueiʹtlvaž lââʹssteâđ',
  'reservation_form.enter_valid_email': 'Piij kudd neʹttpååʹštaddrõs',
  'reservation_form.event_description': 'Lââʹssteâđ',
  'reservation_form.field_max_length': 'Ǩeeʹdd šuurmõskookkadvuõtt lij {maxLength} miârk',
  'reservation_form.must_accept_terms': 'Tuʹst âlgg priimmâd pääiʹǩ õõʹnnimeärrõõzzid što piâzzak vaʹrrjed pääiʹǩ',
  'reservation_form.number_of_participants': 'Vuässõõttimieʹrr',
  'reservation_form.read_terms': 'Leäm lookkâm da priimmâm pääiʹǩ õõʹnnimeärrõõzzid',
  'reservation_form.required_field': 'Pääkklaž teâtt',
  'reservation_form.reserver_email': 'Neʹttpååʹšt',
  'reservation_form.reserver_id': 'Y-tiõtt / person-nââmar',
  'reservation_form.reserver_name': 'Vaʹrrjeei / Vuåkrjeei',
  'reservation_form.reserver_phone_number': 'Teʹlfon',
  'reservation_form.save': 'Ruõkk',
  'reservation_form.saving': 'Ruõkkât...',
  'reservation_form.staff_event': 'Koontâr jiijjâs šõddmõš',
  'reservation_form.staff_event_help': 'Konttâr jiijjâs šõddmõš priimât automaattsânji da oʹdinak pääkklaž teâđ\n                  liâ vaʹrrjeei nõmm da lââʹssteâđ.',
  'reservation_info.address': 'Addrõs:',
  'reservation_info.back': 'Mååusat',
  'reservation_info.billing_address': 'Laasktõsaddrõs:',
  'reservation_info.comments': 'Kommeeʹnt:',
  'reservation_info.comments_help': 'Vaʹrrjõõzz vueiʹtlvaž lââʹssteâđ',
  'reservation_info.event_description': 'Lââʹssteâđ:',
  'reservation_info.help_title': 'Vuäʹpstõõzz vaʹrrjummša',
  'reservation_info.login_required': 'Tuʹst feʹrttai ǩeʹrjtõõttâd sizz, što vuäitak tueʹjjeed vaʹrrjõõzz.',
  'reservation_info.max_per_user': 'Šuurmõsmieʹrr vaʹrrjõõzz / õõʹnni: {amount}',
  'reservation_info.max_period': 'Vaʹrrjõõzz šuurmõskookkadvuõtt:{days, plural, =0 {} one {Â # pÃ¤ivÃ¤} other {Â # peeiʹv¤}}{hours, plural, =0 {} one {Â # čiâss} other {Â # čiâss}}{minutes, plural, =0 {} one {Â # minut} other {Â # minuutt}}.',
  'reservation_info.number_of_participants': 'Vuässõõttimieʹrr¤:',
  'reservation_info.reservable_after_days': 'Vaʹrrjõs âlgg tueʹjjeed uuʹccmõsân {days} {days, plural, one {peeiʹv} other {peeiʹv}} ouddǩiõʹtte.',
  'reservation_info.reservation_info': 'Vaʹrrjõõzz teâđ',
  'reservation_info.reservation_time': 'Vaʹrrjõõzz ääiʹjpodd:',
  'reservation_info.reserver_email': 'Neʹttpååʹšt:',
  'reservation_info.reserver_id': 'Y-tiõtt / person-nââmar:',
  'reservation_info.reserver_name': 'Vaʹrrjeei / Vuåkrjeei',
  'reservation_info.reserver_phone_number': 'Teʹlfon-nââmar:',
  'reservation_info.resource': 'Päiʹǩǩ:',
  'reservation_info.save': 'Ruõkk',
  'reservation_info.saving': 'Ruõkkât...',
  'reservation_list.no_reservations': 'Tuʹst jeäʹla võl ni vooʹps vaʹrrjõõzz.',
  'reservation_modal.confirm_help': 'Leäk-a snäätnai što haaʹlääk tueʹjjeed {num, plural, one {vaʹrrjõõzz äigga} other {vaʹrrjõõzz aaiʹjid}}:',
  'reservation_modal.editing_after': 'Muttsi mâŋŋa:',
  'reservation_modal.editing_are_you_sure': 'Leäk-a snäätnai što haaʹlääk muʹtted vaʹrrjõõzzad?',
  'reservation_modal.editing_before': 'Ouddâl muttsi:',
  'reservation_modal.preliminary_form_help': 'Tiuddâd võl pueʹtti teâđid valmšteei vaʹrrjõõzz diõtt.\n                                Taaʹsnin¤ (*) miõrkkum teâđ liâ pääkklaž.',
  'reservation_modal.preliminary_help': 'Leäk tueʹjjeʹmen valmšteei vaʹrrjõõzz {num, plural, one {äigga} other {aaiʹjid}}:',
  'reservation_modal.title_confirm': 'Vaʹrrjõõzz raʹvvjummuš',
  'reservation_modal.title_editing': 'Muttsi raʹvvjummuš',
  'reservation_modal.title_preliminary': 'Valmšteei vaʹrrjõs',
  'reservation_page.reservation_status_title': 'Vaʹrrjemvueʹǩǩ',
  'reservation_page.reserve_title': 'Tueʹjjed vaʹrrjõõzz',
  'reservation_page.resource_info': 'Lââʹssteâđ',
  'reservation_page.title': '{resourceName}  vaʹrrjemkalenter  Vaʹrrjempäiʹǩǩ',
  'reservation_success.info_email': 'Tääʹrǩab teâđ valmšteei vaʹrrjõõzzâst \n            vuõltteet vaʹrrjõõzz õhttvuõđâst uʹvddum neʹttpååšta',
  'reservation_success.made_preliminary': 'Leäk tueʹjjääm valmšteei vaʹrrjõõzz päikka {name} {times, plural, one {äigga} other {aaiʹjid}}:',
  'reservation_success.sent': 'Vaʹrrjemraukkmõš lij vuõlttuum',
  'resource.image_alt': 'Kartt {resourceName} pääiʹǩest',
  'resource.reserve': 'Tueʹjjed vaʹrrjõõzz',
  'resource.title': '{resourceName}  Vaʹrrjempäiʹǩǩ',
  'search.help_text': 'Oocc pääiʹǩ piijeeʹl ooccâmǩeâdda päikka õhtteei teâđid.',
  'search.no_results': 'Jeäʹla käunnʼjam ni vooʹps ooccâmpuåtti.',
  'search.page_header': 'Ooccmõš',
  'search.title': 'Haku  Vaʹrrjempäiʹǩǩ',
  'search_controls.go_to_selected': 'Mõõn vaalšum sâjja',
  'search_controls.search': 'Oocc',
  'search_controls.today': 'Täʹbbe',
  'search_filters.purpose': 'Aparatt, päiʹǩǩ leʹbe kääzzkõs',
  'search_filters.unit': 'Ǩeʹrjjpõrtt',
  'search_result.details': 'Lââʹssteâđ',
  'search_result.hours_available': '{hours, plural, one {# čiâss} other {# čiâss}} frijjân',
  'search_result.reserve': '. Vaʹrre.',
  'timerange.timestring': 'čiâss {begin} â€“ {end}',
  'timeslot.editing': 'Teevat',
  'timeslot.free': 'Frijj',
  'timeslot.login_to_reserve': 'Vaʹrrjõõzz tueʹjjeem diõtt ǩeʹrjtõõđ sizz tän päikka.',
  'timeslot.not_reservable': 'Iʹlla vaʹrrjemnalla',
  'timeslot.reserved': 'Vaʹrrjum',
  'timeslots.comments': 'Kommeeʹnt',
  'timeslots.functions': 'Tuåimmjummuž',
  'timeslots.not_reservable_today': 'Jeäʹla vaʹrrjemnalla åårrai aäiʹj vaalšem peiʹvven.',
  'timeslots.reserver': 'Vaʹrrjeei',
  'timeslots.status': 'Vaʹrrjemvueʹǩǩ',
  'timeslots.time': 'Äiʹ'
};

export default messages;



/** WEBPACK FOOTER **
 ** ./app/messages/sms.js
 **/